import { render, staticRenderFns } from "./AdminAgencySettings.vue?vue&type=template&id=15afc7ec&"
import script from "./AdminAgencySettings.vue?vue&type=script&lang=js&"
export * from "./AdminAgencySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdminAgencySettings.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDivider,
  VFlex,
  VTab,
  VTabs,
})
